// extracted by mini-css-extract-plugin
export default {"content":"baST7Xuh","button":"KRWSdbkl","description":"f6DpkLIO"};